import { render, staticRenderFns } from "./specifications.form.vue?vue&type=template&id=a6eb8a7e&"
import script from "./specifications.form.vue?vue&type=script&lang=ts&"
export * from "./specifications.form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports